import React from 'react'
import { Box, Typography } from '@mui/material'
import { PencilSimpleLine, Power, Prohibit } from '@phosphor-icons/react'
import FormHeaderDetailActions from '../../components/action_button/FormHeaderDetailActions'
import {
  RBAC_USER_DETAIL_TEXTS,
  rbacUserDetailTitleSx
} from '../pages/shared/rbacUserDetailConstants'

export default function RbacUserDetailToolbar({ user, canManage, onEditUser, onStatusAction }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'stretch', md: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        mt: 3,
        mb: 2
      }}
    >
      <Typography sx={rbacUserDetailTitleSx}>
        {RBAC_USER_DETAIL_TEXTS.detailTitle}
      </Typography>

      {canManage && (
        <FormHeaderDetailActions
          className="form-header-actions--modern form-header-actions--compact-gap"
          iconSize={18}
          secondaryLabel={
            user?.status === 'inactive'
              ? RBAC_USER_DETAIL_TEXTS.activateUser
              : RBAC_USER_DETAIL_TEXTS.deactivateUser
          }
          secondaryIcon={user?.status === 'inactive' ? Power : Prohibit}
          secondaryVariant={user?.status === 'inactive' ? 'success' : 'danger'}
          onSecondary={onStatusAction}
          primaryLabel={RBAC_USER_DETAIL_TEXTS.editUser}
          primaryIcon={PencilSimpleLine}
          onPrimary={onEditUser}
          stackOnMobile
        />
      )}
    </Box>
  )
}
